import amplitude from "amplitude-js";

const prodKey = "6ee05968f5b4666d68c4de865390ca90";
const stagingKey = "9c2594954a4e6ca10fdbff1a299f6e14";
const apiKey =
  process.env.VUE_APP_ENDPOINTS === "production" ? prodKey : stagingKey;
const instance = amplitude.getInstance();
instance.init(apiKey, undefined, { includeUtm: true });
instance.setOptOut(process.env.NODE_ENV === "development");
